<template>
	<!-- TODO 前三名 深色。 后面浅色 -->
	<div class="flag-shape">
		{{ number }}
	</div>
</template>

<script>
export default {
	name: "numberRankFlag",
	props: {
		number: {
			type: [Number, String],
			default: '',
		},
	},
};
</script>

<style lang="less" scoped>
.flag-shape {
	@bg-purple: #D3AD72;
	width: 40px;
	height: 48px;
	font-family: "Microsoft YaHei";
	font-weight: 550;
	user-select: none;
	background-color: @bg-purple;

	clip-path: polygon(100% 100%, 50% 90%, 0 100%, 0 0, 50% 0, 100% 0);
	border-radius: 5.2px 5.2px 5.2px 0 5.2px;
	font-size: 20px;
	font-weight: 550;
	color: #fff;
	display: inline-flex;
	justify-content: center;
	align-items: center;
}
</style>
